import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Protected } from "@/components/Protected";
import { AppShell } from "@/components/AppShell";
import { DriverShell } from "@/components/DriverShell";

import Login from "@/pages/Login";
import Dashboard from "@/pages/owner/Dashboard";
import Reconciliation from "@/pages/owner/Reconciliation";
import CylinderStock from "@/pages/owner/CylinderStock";
import Transactions from "@/pages/owner/Transactions";
import Consumers from "@/pages/owner/Consumers";
import Users from "@/pages/owner/Users";
import Prices from "@/pages/owner/Prices";
import Reports from "@/pages/owner/Reports";
import Billing from "@/pages/admin/Billing";
import Office from "@/pages/office/Office";
import Invoices from "@/pages/office/Invoices";
import CashConfirmation from "@/pages/office/CashConfirmation";
import DriverHome from "@/pages/driver/DriverHome";
import DriverLoad from "@/pages/driver/Load";
import DriverDeliver from "@/pages/driver/Deliver";
import DriverSale from "@/pages/driver/NonConsumerSale";
import DriverReturns from "@/pages/driver/Returns";
import DriverEOD from "@/pages/driver/EOD";

const Back = ({ roles, children }) => (
  <Protected roles={roles}>
    <AppShell>{children}</AppShell>
  </Protected>
);
const Drv = ({ children }) => (
  <Protected roles={["driver"]}>
    <DriverShell>{children}</DriverShell>
  </Protected>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Back roles={["owner", "office"]}><Dashboard /></Back>} />
            <Route path="/reconciliation" element={<Back roles={["owner"]}><Reconciliation /></Back>} />
            <Route path="/cylinder-stock" element={<Back roles={["owner"]}><CylinderStock /></Back>} />
            <Route path="/transactions" element={<Back roles={["owner"]}><Transactions /></Back>} />
            <Route path="/office" element={<Back roles={["office"]}><Office /></Back>} />
            <Route path="/invoices" element={<Back roles={["owner", "office"]}><Invoices /></Back>} />
            <Route path="/cash" element={<Back roles={["office"]}><CashConfirmation /></Back>} />
            <Route path="/consumers" element={<Back roles={["office"]}><Consumers /></Back>} />
            <Route path="/reports" element={<Back roles={["owner", "office"]}><Reports /></Back>} />
            <Route path="/prices" element={<Back roles={["owner", "office"]}><Prices /></Back>} />
            <Route path="/users" element={<Back roles={["owner"]}><Users /></Back>} />
            <Route path="/billing" element={<Back roles={["admin"]}><Billing /></Back>} />
            <Route path="/driver" element={<Drv><DriverHome /></Drv>} />
            <Route path="/driver/load" element={<Drv><DriverLoad /></Drv>} />
            <Route path="/driver/deliver" element={<Drv><DriverDeliver /></Drv>} />
            <Route path="/driver/sale" element={<Drv><DriverSale /></Drv>} />
            <Route path="/driver/returns" element={<Drv><DriverReturns /></Drv>} />
            <Route path="/driver/eod" element={<Drv><DriverEOD /></Drv>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
